import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { components } from 'react-select';

const Option = props => {
  const { data, selectProps } = props;
  const descriptionKey = selectProps.descriptionKey || 'description';
  const label = selectProps.getOptionLabel ? selectProps.getOptionLabel(data) : data.label;
  const description = data[descriptionKey];

  return (
    <components.Option
      {...props}
      className={classnames(props.className, data.className, {
        'Select__option--with-description': Boolean(description),
      })}
    >
      <div className="Select__option-label" title={label}>{label}</div>
      {description ? <div className="Select__option-description">{description}</div> : null}
    </components.Option>
  );
};

Option.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  selectProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default Option;
